import { useMemo } from 'react';
import * as THREE from 'three';

/**
 * Atmosphere — shell esterna con shader fresnel per alone atmosferico
 * color chartreuse → ciano, tipico "day-side glow" delle foto NASA.
 */
export default function Atmosphere({ radius = 1, color = '#b4ff00', intensity = 1.6 }) {
  const material = useMemo(() => new THREE.ShaderMaterial({
    uniforms: {
      uColor: { value: new THREE.Color(color) },
      uIntensity: { value: intensity },
    },
    vertexShader: `
      varying vec3 vNormal;
      varying vec3 vPos;
      void main() {
        vNormal = normalize(normalMatrix * normal);
        vec4 mvPos = modelViewMatrix * vec4(position, 1.0);
        vPos = -mvPos.xyz;
        gl_Position = projectionMatrix * mvPos;
      }
    `,
    fragmentShader: `
      uniform vec3 uColor;
      uniform float uIntensity;
      varying vec3 vNormal;
      varying vec3 vPos;
      void main() {
        vec3 viewDir = normalize(vPos);
        float fres = pow(1.0 - abs(dot(viewDir, vNormal)), 2.5);
        gl_FragColor = vec4(uColor, fres * uIntensity);
      }
    `,
    blending: THREE.AdditiveBlending,
    side: THREE.BackSide,
    transparent: true,
    depthWrite: false,
  }), [color, intensity]);

  return (
    <mesh scale={1.15}>
      <sphereGeometry args={[radius, 64, 64]} />
      <primitive object={material} attach="material" />
    </mesh>
  );
}
